module.exports = __webpack_public_path__ + "static/media/home_nav_logo_black.f96371aa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/home_nav_logo_black.svg
// module id = 417
// module chunks = 0